import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { css } from "@emotion/core"
import {
  weddingPartyMember,
  weddingPartyContent,
  contentRight,
  weddingPartyMemberImage,
} from "../weddingPartyMember"

const imageWrapper = css`
  position: relative;
  width: 350px;

  @media screen and (min-width: 500px) {
    top: -30px;
  }

  @media screen and (min-width: 680px) {
    position: absolute;
    top: 55px;
    left: -70px;
  }

  @media screen and (min-width: 860px) {
    width: 460px;
  }
`

const Flora = props => {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "flora.png" }) {
        childImageSharp {
          # Specify the image processing specifications right in the query.
          # Makes it trivial to update as your page's design changes.
          fluid(maxWidth: 480) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <div css={weddingPartyMember}>
      <div css={[weddingPartyMemberImage, imageWrapper]}>
        <Img
          fluid={data.file.childImageSharp.fluid}
          imgStyle={{ objectFit: "contain" }}
          {...props}
        />
      </div>
      <div css={[weddingPartyContent, contentRight]}>
        <div>
          <h2>Flora Cervantes</h2>
          <h4>Maid of Honor</h4>
          <p>
            They met in San Francisco over the many tears sewing a garment
            requires, but they harnessed a deeper understanding of one another
            on their long walks through the Tenderloin.
          </p>
        </div>
      </div>
    </div>
  )
}

export default Flora
